import { h } from 'preact';
import { useStyles } from '../../../../common/hooks';
import { secondsToHHMMSS } from '../../../../common/utils';
import { TIME_DISPLAY_FONT_SIZE_LARGE, TIME_DISPLAY_FONT_SIZE_SMALL, TIME_DISPLAY_WIDTH_LARGE, TIME_DISPLAY_WIDTH_SMALL, TIME_DISPLAY_WRAPPER_STYLE } from './styles';

function TimeDisplay({
  time,
  small,
  hidden,
  last,
  displayFn = secondsToHHMMSS,
  style = {},
  ariaHidden = 'true'
}) {
  const setStyles = useStyles();
  return hidden ? null : (
    <div
      className="ftv-magneto-time"
      style={{
        ...setStyles(TIME_DISPLAY_WRAPPER_STYLE),
        ...{
          fontSize: small ? TIME_DISPLAY_FONT_SIZE_SMALL : TIME_DISPLAY_FONT_SIZE_LARGE,
          width: small ? TIME_DISPLAY_WIDTH_SMALL : TIME_DISPLAY_WIDTH_LARGE,
          textAlign: last ? 'right' : 'left'
        },
        ...style
      }}
      aria-hidden={ariaHidden}
    >
      {displayFn(time)}
    </div>
  );
}

export default TimeDisplay;
